import { StyleSheet } from 'aphrodite/no-important';
import { POSITION, COLORS, FONTS } from '../styles';

export default StyleSheet.create({
  addressSection: {
    position: POSITION.RELATIVE,
    padding: '60px 20px',
    background: COLORS.WHITE,
    textAlign: 'center',

    '@media (max-width: 768px)': {
      padding: '40px 20px',
    },
  },

  addressInner: {
    position: POSITION.RELATIVE,
    maxWidth: 800,
    margin: '0 auto',
    textAlign: 'center',
    zIndex: 10,
    ...FONTS.OPEN_SANS,
  },

  addressTitle: {
    position: POSITION.RELATIVE,
    display: 'inline-block',
    ...FONTS.RAMA_E,
    fontSize: 36,
    fontWeight: 400,
    padding: '10px',
    marginBottom: 40,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: COLORS.WHITE,
    background: COLORS.PINK,

    '@media (max-width: 640px)': {
      fontSize: 28,
    },
  },

  addressText: {
    fontSize: 16,
    lineHeight: 1.8,
    color: COLORS.GRAY5,

    ':nth-child(n) a': {
      color: COLORS.PINK_DARK,
      textDecoration: 'none',
      fontWeight: 600,
    },

    ':nth-child(n) a:hover': {
      textDecoration: 'underline',
    },
  },
});
